module.exports = __webpack_public_path__ + "img/integrations-prestashop.c33936d9.png";